// Importa os módulos necessários do Firebase
import { initializeApp } from 'firebase/app';
import { getFirestore, writeBatch, addDoc, doc, setDoc, collection, where, query, getDocs, updateDoc, getDoc } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';  // Importa o módulo de Storage do Firebase

// Configuração do Firebase
const firebaseConfig = {
  apiKey: "AIzaSyAwI_RMfhqJm9xb8QUtFpEfgMNyC2QbSso",
  authDomain: "hb-escola.firebaseapp.com",
  projectId: "hb-escola",
  storageBucket: "hb-escola.appspot.com",
  messagingSenderId: "410319379013",
  appId: "1:410319379013:web:6de22f3e607d0c1bb9612c",
  measurementId: "G-HDFF56E1ET"
};

// Inicializa o Firebase
const app = initializeApp(firebaseConfig);  // Inicializa e armazena o app
const firestore = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);

// Exporta o app junto com outras instâncias
export { app, firestore, auth, storage, writeBatch, addDoc, doc, setDoc, collection, where, query, getDocs, updateDoc, getDoc };
